import type { ChecklistItem } from "@/api/content";
import { Button } from "@/components";
import { useLang } from "@/i18n/LanguageContext";
import type { BlockEditorProps } from "./types";

export function ChecklistEditor({ content, onChange }: BlockEditorProps) {
  const { t } = useLang();
  const items = content.items ?? [];
  const setItems = (next: ChecklistItem[]) => onChange({ ...content, items: next });
  const patch = (i: number, p: Partial<ChecklistItem>) => setItems(items.map((it, j) => (j === i ? { ...it, ...p } : it)));

  return (
    <div>
      <div className="field">
        <label htmlFor="cl-intro">{t("Intro (optioneel)", "Intro (optional)")}</label>
        <input id="cl-intro" value={content.intro ?? ""} onChange={(e) => onChange({ ...content, intro: e.target.value })} placeholder={t("Korte toelichting boven de lijst", "Short note above the list")} />
      </div>
      {items.length === 0 && <p className="no-data-message">{t("Nog geen punten.", "No items yet.")}</p>}
      {items.map((it, i) => (
        <div key={i} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 8 }}>
          <input style={{ flex: 1, border: "1px solid var(--line)", borderRadius: 4, padding: "9px 11px" }} value={it.text} onChange={(e) => patch(i, { text: e.target.value })} placeholder={`${t("Punt", "Item")} ${i + 1}`} />
          <label className="ack-check" style={{ fontWeight: 500, fontSize: 13.5, whiteSpace: "nowrap" }}>
            <input type="checkbox" checked={it.required} onChange={(e) => patch(i, { required: e.target.checked })} />
            {t("verplicht", "required")}
          </label>
          <button className="icon-btn" title={t("Verwijderen", "Remove")} onClick={() => setItems(items.filter((_, j) => j !== i))}>×</button>
        </div>
      ))}
      <Button variant="outline" onClick={() => setItems([...items, { text: "", required: false }])}>+ {t("Punt", "Item")}</Button>
    </div>
  );
}
